import { Injectable } from '@angular/core';
import { ToastService } from '../shared/toast/toast.service';

@Injectable({
  providedIn: 'root'
})
export class AuthAlertService {

  constructor(private toast: ToastService) { }

  public showNoAuthentication(): void {
    this.toast.showWarning('Ops, usuário não autenticado.');
  }

  public showNoPermissionArea(): void {
    this.toast.showNoPermission('Desculpe, sem permissão para acessar este recurso.');
  }

  public showNoPermissionAction(): void {
    this.toast.showNoPermission('Desculpe, sem permissão para executar esta operação.');
  }
}
